module.exports = __webpack_public_path__ + "static/media/striped_bar_M3_tall.cc410276.svg";